import React from 'react';
import { addTargetBlank } from '../utils';

const SimpleMessage = ({message, className, style, isAutopilot}) => {
	let text = message.value;

	if (isAutopilot) {
		text = addTargetBlank(text);
	}

	return (
		<p
			className={className}
			dangerouslySetInnerHTML={{ __html: text.replace(/\\/g, '"') }}
			style={style}
		/>
	);
};

export default SimpleMessage;